import{useRef as r,useEffect as t}from"react";var e=()=>{var e=r(!1);return t((()=>(e.current=!0,()=>{e.current=!1})),[]),e.current};export{e as u};
//# sourceMappingURL=useIsMounted-10bb68a9.js.map
